import {trackEvent} from "./analytics"

export const handleNewRoute = (eventID, userID) => ({previous, url}) => {
	trackEvent({
		eventID,
		from: previous,
		to: url,
		type: "Venue Navigation",
		userID,
	})
}
